import React, { useEffect, useRef, useState } from 'react';
import GIF from 'gif.js';
import html2canvas from 'html2canvas';
import { saveAs } from 'file-saver';

export default function TimerComSpinnerControlado() {
  const [time, setTime] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [isRecordingGif, setRecordingGif] = useState(false);
  const intervalRef = useRef(null);
  const divRef = useRef(null);
  const [gif, setGif] = useState(null);

  const iniciarTimer = () => {
    if (intervalRef.current) return;
    setIsRunning(true);
    intervalRef.current = setInterval(() => {
      setTime((prev) => prev + 10);
    }, 10);
  };

  const handleIniciarGif = () => {
    
    if(!isRecordingGif){
        setRecordingGif(true);
    }
    if(!isRunning){
        iniciarTimer();
    } else {
        pausarTimer();
    }
    
  }

  const pausarTimer = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
    setIsRunning(false);
  };

  const resetarTimer = () => {
    pausarTimer();
    setTime(0);
  };

  useEffect(() => {
       if (isRecordingGif) {
         const gif = new GIF({
           workers: 2,
           quality: 10,
           width: divRef.current.offsetWidth,
           height: divRef.current.offsetHeight,
           workerScript: '/gif.worker.js'
         });

         setGif(gif);

         const intervalId = setInterval(() => {
           html2canvas(divRef.current).then(canvas => {
             gif.addFrame(canvas, { copy: true, delay: 50 });
           });
         }, 50);

         gif.on('finished', (blob) => {
           saveAs(blob, 'div_to_gif.gif');
           setRecordingGif(false);
         });
       }
     }, [isRecordingGif]);

     const handleStopRecording = () => {
            resetarTimer();
           if (gif) {
             gif.render();
           }
     };

  return (
    <div  style={{ fontFamily: 'monospace', fontSize: '20px' }}>
      <div ref={divRef} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <span>{(time / 1000).toFixed(2)}s</span>
      </div>

      <button onClick={handleIniciarGif}>{isRunning && (
        'Pausar'
      )}
      {!isRunning && (
        'Iniciar'
      )}</button>
      {isRecordingGif && (<button onClick={handleStopRecording}>
           Parar Gravação
         </button>)}
      

      <style>{`
        .spinner {
          width: 20px;
          height: 20px;
          border: 3px solid #ccc;
          border-top: 3px solid #333;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
